export const UtilityMixin = {
  methods: {
    ddToDms_lat(lat) {
      const vm=this
      var lat = lat;
      var latResult;
      lat = parseFloat(lat);  
      latResult = (lat >= 0)? 'N ' : 'S ';
      latResult += vm.getDms(lat);
      return latResult;
   },   
 ddToDms_lon(lng) {
    const vm=this
   var lng = lng;
   var lngResult;
   lng = parseFloat(lng);
   lngResult = (lng >= 0)? 'E ' : 'W ';
   lngResult += vm.getDms(lng);
   return lngResult;
},
getDms(val) {
  var valDeg, valMin, valSec, result;
  val = Math.abs(val);
  valDeg = Math.floor(val);
  result = valDeg + "° ";
  valMin = Math.floor((val - valDeg) * 60);
  result += valMin + "' ";
  valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
  result += valSec + '" ';
  return result;
},
    getDecimalSeparator() {
  //fallback  
     var decSep = ".";

      try {
          // this works in FF, Chrome, IE, Safari and Opera
          var sep = parseFloat(3/2).toLocaleString().substring(1,2);
          if (sep === '.' || sep === ',') {
              decSep = sep;
          }
      } catch(e){}

      return decSep;
  },
   getIcon(obj,isSelected) {
                const vm=this
                var colorMode = 'rgb(0,255,0)'
                var color = (isSelected ? 'rgb(255,0,0)' : 'rgb(51,204,51)')
                var myIcon
               
                var offset = (obj.id>9 ? 10:12)
                var mySvg = 'data:image/svg+xml;utf-8, \
      <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"> \
      <polyline points="1,1  29,1  29,20 20,20 15,29 10,20 1,20 1,0" style="stroke:' + colorMode + '; stroke-width: 2; fill: ' + color + ';"/>\
       <text x="'+offset+'" y="14" fill="black"  font-size="10">' + obj.id + '</text></svg>'
                myIcon = {
                    url: mySvg,
                    anchor: new google.maps.Point(15, 30),
                    size: new google.maps.Size(30, 30)
                }
                return myIcon;
            }
       
       ,
         moderateBounds: function(bounds) {
      // Don't zoom in too far on only one marker
      if(bounds.getNorthEast().equals(bounds.getSouthWest())) {
        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }
      return bounds
    },
    getPosBounds: function(pos) {
      var bounds = new google.maps.LatLngBounds()
      bounds.extend(pos)
      return this.moderateBounds(bounds)
    },

        getMapBounds: function(data) {
      var bounds = new google.maps.LatLngBounds();
      for(var i = 0; i < data.length; i++) {
        if(data[i].lat > 0.01) {
          bounds.extend(new google.maps.LatLng(data[i].lat, data[i].lon))
        }
      }
      return this.moderateBounds(bounds)
    },
                centerMarker(item) {
                const vm = this
                var pos = {
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.lon)
                }
                var bounds = vm.getPosBounds(pos)
                vm.$refs.mmm.$mapPromise.then(() => {
                    vm.$refs.mmm.$mapObject.fitBounds(bounds)
                    vm.center = vm.$refs.mmm.$mapObject.getCenter()
                    /*new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map:  vm.$refs.mmm.$mapObject,
            center: pos,
            radius: 500
          });*/


                })
            },
       centerAllMarkers() {
                const vm = this
                vm.sel_id=-1
                vm.selectedItem=null
                var bounds = vm.getMapBounds(vm.rows)
                vm.$refs.mmm.$mapPromise.then(() => {
                    vm.$refs.mmm.$mapObject.fitBounds(bounds);
                    vm.center = vm.$refs.mmm.$mapObject.getCenter();
                })
            },


          }

}